import actionLevers from './action-levers/indicator-action-levers.locales'
import retirementSavings from './retirement-savings/indicator-retirement-savings.locales'
import esg from './risk-level/esg/indicator-esg.types.locales'
import riskLevel from './risk-level/risk-level-gauge/indicator-risk-level.locales'
import taxBrackets from './tax-brackets/indicator-tax-brackets.locales'
import taxCeiling from './tax-ceiling/indicator-tax-ceiling.locales'
import taxData from './tax-data/indicator-tax-data.locales'
import taxationKeyFigures from './taxation-key-figures/indicator-taxation-key-figures.locales'
import wealthDistribution from './wealth-distribution/indicator-wealth-distribution.locales'
import wealthProjection from './wealth-projection/indicator-wealth-projection.locales'

export const i18nIndicators = 'components.indicators.'

export default {
  actionLevers,
  retirementSavings,
  riskLevel,
  taxBrackets,
  taxCeiling,
  taxData,
  taxationKeyFigures,
  wealthDistribution,
  wealthProjection,
  esg,
}
